export default __webpack_public_path__ + "static/media/trend-neutral.65cb16b4.svg";